<template>
  <div id="topTips">
    <div class="top-warning">
      <div class="top-warning-inner">
        <ul>
          <li>{{ $t('other.topTips1') }}</li>
          <li>{{ $t('other.topTips2') }}</li>
        </ul>
        <div class="top-warning-check-group" @click="domClick">
          <input type="checkbox" name="" id="warningChecked" />
          <label for="warningChecked">
            {{ $t('other.topTips3') }} <br />
            {{ $t('other.topTips4') }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'topTips',
  data() {
    return {}
  },
  mounted() {},
  methods: {
    domClick() {
      let dom = document.getElementById('warningChecked')
      let topTips = document.getElementById('topTips')
      if (dom.checked) {
        setTimeout(() => {
          topTips.style.transition =
            'opacity 0.5s ease, height 0.5s ease, padding 0.5s ease'
          topTips.style.opacity = '0'
          topTips.style.height = '0'
          topTips.style.padding = '0'
          topTips.style.overflow = 'hidden'
          setTimeout(() => {
            topTips.style.display = 'none'
            localStorage.setItem('topTips', '0')
          }, 500)
        }, 1000)
        // topTips.style.display = 'none'
      }
    },
  },
}
</script>
<style>
.top-warning {
  padding: 8px 16px;
  background-color: #212529;
  color: #fff;
  font-size: 12px;
}
@media (max-width: 575.98px) {
  .top-warning {
    padding: 6px 12px;
  }
}
.top-warning ul {
  margin-bottom: 12px;
  padding-left: 24px;
  list-style-type: disc;
}
.top-warning ul li {
  display: list-item;
  unicode-bidi: isolate;
  list-style-type: disc;
}
.top-warning-check-group {
  padding-left: 12px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: max-content;
}
.top-warning-check-group input[type='checkbox'] {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: #ccc solid 1px;
  background-color: #fff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}
.top-warning-check-group input[type='checkbox']:checked {
  background-color: #28a47f;
  border-color: #28a47f;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><polyline points="13.3 4.82 6.94 11.18 2.7 6.94" fill="none" stroke="%23fff" stroke-miterlimit="10" stroke-width="3"/></svg>');
}
.top-warning-check-group label {
  flex: 1 0 0;
  cursor: pointer;
}
::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: auto !important;
}
</style>
<!-- 移动端样式 -->
<style>
.top-warning {
  padding: 8px 16px;
  background-color: #212529;
  color: #fff;
  font-size: 12px;
}
.top-warning ul {
  /* 减小移动端列表项的底部外边距，以节省垂直空间 */
  margin-bottom: 8px;
  padding-left: 20px; /* 稍微减小列表左侧内边距 */
  list-style-type: disc;
}
.top-warning ul li {
  display: list-item;
  unicode-bidi: isolate;
  list-style-type: disc;
  /* 确保列表项在小屏幕上不会太分散 */
  margin-bottom: 4px;
}
.top-warning-check-group {
  padding-left: 12px;
  display: flex;
  gap: 12px;
  /* 在所有尺寸上都使用 flex-start 保证复选框和文字顶部对齐 */
  align-items: flex-start;
  width: 100%; /* 让复选框组占据全部宽度 */
}
/* 针对更小的移动设备进行样式调整 */
@media (max-width: 575.98px) {
  .top-warning {
    padding: 6px 12px;
  }
  .top-warning ul {
    /* 进一步减小列表左侧内边距 */
    padding-left: 16px;
  }
  .top-warning-check-group {
    /* 在极小的屏幕上可能需要调整间距 */
    gap: 8px;
    padding-left: 8px;
  }
}
/*
  复选框和标签的样式保持不变，
  因为它们已经处理了基本的对齐和视觉效果。
*/
.top-warning-check-group input[type='checkbox'] {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: #ccc solid 1px;
  background-color: #fff;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}
.top-warning-check-group input[type='checkbox']:checked {
  background-color: #28a47f;
  border-color: #28a47f;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><polyline points="13.3 4.82 6.94 11.18 2.7 6.94" fill="none" stroke="%23fff" stroke-miterlimit="10" stroke-width="3"/></svg>');
}
.top-warning-check-group label {
  flex: 1 0 0;
  cursor: pointer;
}
::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: auto !important;
}
</style>
